if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {
          once: true,
          signal: this.controller.signal,
        });
      } else {
        this.initialize();
      }
    }

    initialize() {
      this.tabs = Array.from(this.querySelectorAll('.cts-tab'));
      this.panels = Array.from(this.querySelectorAll('.cts-products-slider'));
      this.swipers = new Map();
      const options = { signal: this.controller.signal };

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(tab), options);
        tab.addEventListener('keydown', (event) => {
          let targetIndex;
          if (event.key === 'ArrowRight') targetIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') targetIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = this.tabs.length - 1;
          if (targetIndex === undefined) return;
          event.preventDefault();
          this.tabs[targetIndex].focus({ preventScroll: true });
          this.selectTab(this.tabs[targetIndex]);
        }, options);
      });

      if (this.tabs.length) this.selectTab(this.tabs[0]);
    }

    selectTab(tab) {
      const panel = this.panels.find((item) => item.id === tab.getAttribute('aria-controls'));
      if (!panel) return;
      this.tabs.forEach((item) => {
        const selected = item === tab;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((item) => { item.hidden = item !== panel; });

      if (typeof Swiper === 'undefined') return;
      if (this.swipers.has(panel)) {
        this.swipers.get(panel).update();
        return;
      }

      // Initialize after revealing the panel so Swiper measures its actual width.
      this.swipers.set(panel, new Swiper(panel.querySelector('.swiper'), {
        slidesPerView: 1.12,
        spaceBetween: 12,
        slidesPerGroup: 1,
        speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
        watchOverflow: true,
        grabCursor: true,
        navigation: {
          nextEl: panel.querySelector('.next'),
          prevEl: panel.querySelector('.prev'),
        },
        scrollbar: {
          el: panel.querySelector('.swiper-scrollbar'),
          draggable: true,
          hide: false,
        },
        a11y: {
          prevSlideMessage: 'Previous products',
          nextSlideMessage: 'Next products',
        },
        breakpoints: {
          600: { slidesPerView: 2.12, spaceBetween: 16 },
          768: { slidesPerView: 1.6, spaceBetween: 16 },
          1024: { slidesPerView: 2.5, spaceBetween: 20 },
        },
      }));
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.swipers?.forEach((swiper) => swiper.destroy(true, true));
    }
  });
}
